"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ListItem_1 = tslib_1.__importDefault(require("@material-ui/core/ListItem"));
var FormControlLabel_1 = tslib_1.__importDefault(require("@material-ui/core/FormControlLabel"));
var Checkbox_1 = require("../Checkbox");
var DropdownListItem = function (_a) {
    var label = _a.label, selected = _a.selected, onClick = _a.onClick, _b = _a.indeterminate, indeterminate = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? selected : _c;
    return (react_1.default.createElement(StyledListItem, { role: "listitem", classes: { root: 'root' }, selected: selected, disableGutters: true },
        react_1.default.createElement(StyledFormControlLabel, { classes: { root: 'root', label: 'label' }, label: label, control: react_1.default.createElement(Checkbox_1.Checkbox, { checked: checked, onChange: onClick, indeterminate: indeterminate }) })));
};
exports.default = DropdownListItem;
var StyledFormControlLabel = styled_components_1.default(FormControlLabel_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  &&.root {\n    padding: 0 2.8rem;\n    margin: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .label {\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    margin-left: 1rem;\n  }\n"], ["\n  &&.root {\n    padding: 0 2.8rem;\n    margin: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .label {\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    margin-left: 1rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
});
var StyledListItem = styled_components_1.default(function (_a) {
    var selected = _a.selected, rest = tslib_1.__rest(_a, ["selected"]);
    return (react_1.default.createElement(ListItem_1.default, tslib_1.__assign({}, rest)));
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  && {\n    height: 3.2rem;\n    margin: 0.2rem 0;\n    background-color: ", ";\n    padding: 0;\n  }\n\n  &&:hover {\n    background-color: ", ";\n  }\n"], ["\n  && {\n    height: 3.2rem;\n    margin: 0.2rem 0;\n    background-color: ",
    ";\n    padding: 0;\n  }\n\n  &&:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? '#BDF0F7' : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[50];
});
var templateObject_1, templateObject_2;
